import React, { useEffect, useState } from 'react';
import { Tooltip } from '@progress/kendo-react-tooltip';
import TooltipTemplate from '../components/TooltipTemplate';
import mData from '../hybriddata/mainform.json';
// import '../styles/card-style.css';

const FinancingSelection = (props) => {

    useEffect(() => {

        console.log('@FinancingSelection useEffect');
        return () => {
        }
    }, []);

    return (
        <div className="m-scroll-row inputPair">
            <div id='STP' className="pf-col pf-col-margin">
                <div className={(props.selectedBizCard === mData.bizFinanceType.Online) ? 'prefFinanceFontSize yellowbox' : 'prefFinanceFontSize greybox'}
                    onClick={(e) => {
                        e.preventDefault();
                        if (!props.isEditForm) {
                            props.setSelectedBizCard(mData.bizFinanceType.Online);
                            props.onSelect(mData.bizFinanceType.Online);
                        }
                    }}>
                    <div className='yellowiconbox yellowiconboxLeftAlign'>
                        {/* <img src={onlineIcon} alt="icon" /> */}
                        <span className='prefFinanceYellowBoxTxt'>
                            Easy Application, 100% Online
                        </span>
                    </div>
                    <div className='prefFinanceTitleDivH'>
                        <div className='prefFinanceTitle txt-ws-initial'>
                            Online Business Financing
                        </div>
                        <div className='txt-ws-initial'>{"Term Financing for working capital up to S"+mData.STPFinancingAmt.maxTxt}</div>
                    </div>
                    <div className="divgreylineCpf" style={{ marginTop: '8px', marginBottom: '12px' }} />
                    <div className='dotlistDivH'>
                        <ul className='dotlist'>
                            <li>100% online application and approval</li>
                            <li>Fast disbursement</li>
                            <li>No collateral required</li>
                            <li>No financial or bank statement required</li>
                        </ul>
                    </div>
                    <div className="divgreylineCpf" style={{ marginBottom: '12px' }} />
                    <div>
                        <div className='greyLabel t-full-col'>
                        LOAN AMOUNT
                        </div>
                        <div className='t-full-col txt-ws-initial'>
                            {'S'+mData.STPFinancingAmt.minTxt +' - S'+mData.STPFinancingAmt.maxTxt}
                        </div>
                        <br/>
                        <div className='greyLabel t-full-col'>
                        TERM
                        </div>
                        <div className='txt-ws-initial'>
                            Up to 5 years
                        </div>
                    </div>
                    <div className="row">
                        <br />                
                    </div>
                    <div className='padTop1' >
                        <div className='greyLabel'>REQUIREMENT</div>
                        <ul className='dotlist'>
                            <li>Must have access to MyInfo Business</li>
                            <li>Maximum annual turnover at S$20 million</li>
                            <li>Minimum 1 year incorporation & key man experience</li>
                            <li>Singapore registered company, up to 5 owners</li>
                        </ul>
                    </div>
                </div>
            </div>

            <div id='AIP' className="pf-col pf-col-margin">

                <div className={(props.selectedBizCard === mData.bizFinanceType.AIP) ? 'prefFinanceFontSize yellowbox' : 'prefFinanceFontSize greybox'} onClick={(e) => {
                    e.preventDefault();
                    if (!props.isEditForm) {
                        props.setSelectedBizCard(mData.bizFinanceType.AIP);
                        props.onSelect(mData.bizFinanceType.AIP);
                    }
                }}>
                    <div className='yellowiconbox yellowiconboxLeftAlign2'>
                        <span className='prefFinanceYellowBoxTxt'>
                        Fast-Track Your Approval In-Principle
                        </span>
                    </div>
                    <div className='prefFinanceTitleDivH'>
                        <div className='prefFinanceTitle'>Approval In-Principle Property Financing</div>
                        <div className='txt-ws-initial'>Term financing of up to S$10 million for property purchase</div>
                    </div>
                    <div className="divgreylineCpf" style={{ marginTop: '8px', marginBottom: '12px' }} />
                    <div className='dotlistDivH'>
                    <ul className='dotlist'>
                        <li>End-to-end consultation from our dedicated sales personnel</li>
                        <li>Approval In-Principle for eligible customers</li>
                        <li>Up to 30 years loan tenure</li>
                    </ul>
                    </div>
                    <div className="divgreylineCpf" style={{ marginBottom: '12px' }} />

                    <div>
                        <div className='greyLabel t-full-col'>
                        AMOUNT
                        </div>
                        <div className='t-full-col txt-ws-initial'>
                            {'S$200,000 - S$10,000,000'}
                        </div>
                        <br/>
                        <div className='greyLabel t-full-col'>
                        TERM
                        </div>
                        <div className='txt-ws-initial'>
                            Up to 30 years
                        </div>
                    </div>
                    <div className="row">
                        <br />
                    </div>

                    <div className='padTop1'>
                        <div className='greyLabel'>REQUIREMENT</div>
                        <ul className='dotlist'>
                            <li>Must have access to MyInfo Business</li>
                            <li>Financial statement and bank statements</li>
                            {/* <li>Singapore registered company, up to 10 owners</li> */}
                            <li>For commercial and industrial properties only</li>
                        </ul>
                    </div>
                </div>
            </div>

            <div id='Hybrid' className="pf-col">
                <div className={(props.selectedBizCard === mData.bizFinanceType.Personalised) ? 'prefFinanceFontSize yellowbox' : 'prefFinanceFontSize greybox'} onClick={(e) => {
                    e.preventDefault();
                    if (!props.isEditForm) {
                        props.setSelectedBizCard(mData.bizFinanceType.Personalised);
                        props.onSelect(mData.bizFinanceType.Personalised);
                    }
                }}>
                <div className='yellowiconbox yellowiconboxLeftAlign3'>
                    {/* <img src={customIcon} alt="CIcon" /> */}
                    <span className='prefFinanceYellowBoxTxt'>
                        Customisable to Your Business Needs
                    </span>
                </div>
                <div className='prefFinanceTitleDivH'>
                    <div className='prefFinanceTitle'>Personalised Business Financing</div>
                    <div className='txt-ws-initial'>Customisable financing up to S$10 million</div>
                </div>
                <div className="divgreylineCpf" style={{ marginTop: '8px', marginBottom: '12px' }} />
                <div className='dotlistDivH'>
                    <ul className='dotlist'>
                        <li>End-to-end consultation from our dedicated sales personnel</li>
                        <li>Wide range of financing solutions</li>
                        <li>Minimum branch visit required</li>
                    </ul>
                </div>
                <div className="divgreylineCpf" style={{ marginBottom: '12px' }} />
            <div>
            <div>
                <div className='greyLabel t-full-col'>
                    AMOUNT
                </div>
                <div className='t-full-col txt-ws-initial'>
                    S$20,000 - S$10,000,000
                </div>
                <br/>
                <div className='greyLabel t-full-col'>
                    TERM
                </div>
                <div className='t-full-col txt-ws-initial'>
                    <span style={{display:'-webkit-inline-box'}}>
                        Up to 30 years / revolving&nbsp;
                        <Tooltip id={'ttIsamicAcctI'} content={(props) =>
                            <TooltipTemplate id={'ttIsamicAcctI'} title={props.title} />}
                                anchorElement={'target'} position={'right'} >
                                <span className="k-icon k-i-information" style={{ color: '#979797' }} title={'Revolving - No fixed tenure of repayment. Examples include overdrafts and credit lines.'}></span>
                        </Tooltip>
                    </span>
                </div>
            </div>

             
        </div>
        <div className="row">
            <br />
        </div>

        <div className='padTop1'>
            <div className='greyLabel'>REQUIREMENT</div>
                <ul className='dotlist'>
                <li>Must have access to MyInfo Business</li>
                <li>Financial statement and bank statements</li>
                <li>Minimum 1 year incorporation (except property loan)</li>
                {/* <li>Singapore registered company, up to 10 owners</li> */}
                </ul>
            </div>
        </div>
            </div>
        </div>
    )
}

export default FinancingSelection;